import { get } from "lodash-es";

import { isBlank } from './helpers';
import { camelCaseKeys } from './object';

export const defaultNumber = (value: number): number => (value == null ? 0 : value);

function mapPmpData(adGroup: any) {
  let pmpData = get(adGroup, "pmp_data");
  if (pmpData) {
    const dealBidFloor = get(adGroup, "pmp_data.deal_bid_floor", 0);
    pmpData = {
      ...camelCaseKeys(adGroup.pmp_data),
      creativeType: String(adGroup.pmp_data.creative_type),
      dealBidFloor: (defaultNumber(dealBidFloor) / 100).toFixed(2),
    }
  }
  return pmpData;
}

export default function mapAdGroupToForm(adGroup: any): any {
  const pmpData = mapPmpData(adGroup);

  return {
    ...camelCaseKeys(adGroup),
    maxBid: (defaultNumber(adGroup.max_bid) / 100).toFixed(2),
    spendPercent: isBlank(adGroup.spend_percent) ? '' : defaultNumber(adGroup.spend_percent).toString(),
    campaignUrls: adGroup.campaign_urls.map((campaignUrl) => ({ value: campaignUrl })),
    pixelUrls: adGroup.pixel_urls.map((pixelUrl) => ({ value: pixelUrl })),
    targetingsEnabled: {
      ...adGroup.targetings_enabled,
      DEVICE_COUNTRIES: true,
      needs_tn_user_id: adGroup.targeting_profile?.needs_tn_user_id,
      location_fetch_enabled: adGroup.targeting_profile?.location_fetch_enabled,
    },
    targetingProfile: adGroup.targeting_profile,
    pmpData,
    isExcludedLocationsFormDirty: false,
  };
}
